// THE GOLDEN GLINT, on the field: when game/glint.js says a glint is up (GlintUp) a row is chosen and gold specks sparkle on it
// until the window passes (GlintGone) or a paw click catches it (GlintCaught — a gold burst). The sound is loopFeedback's.
import { Events, on } from '../ui/eventBus.js'

const GOLD = [1.0, 0.86, 0.42]

export function createGlintFx({ rice, fx }) {
  let row = null, timer = null
  const stop = () => { if (timer) clearInterval(timer); timer = null; row = null }
  const twinkle = () => {
    if (!row) return
    const z = row.z0 + Math.random() * (row.z1 - row.z0)
    fx.specks(row.x, row.y + 0.04, z, 2, GOLD, 0.5, 0.05)
  }
  on(Events.GlintUp, () => {
    stop()
    row = rice.randomRow()
    if (!row) return
    fx.specks(row.x, row.y + 0.05, (row.z0 + row.z1) / 2, 6, GOLD, 0.6, 0.06)
    timer = setInterval(twinkle, 110)
  })
  on(Events.GlintGone, stop)
  on(Events.GlintCaught, () => { if (row) fx.burst(row.x, row.y, (row.z0 + row.z1) / 2, 12, GOLD); stop() })
  if (import.meta.env?.DEV) window.__glintFx = { row: () => (row ? { k: row.k, key: row.key, ri: row.ri, x: +row.x.toFixed(3), z: +((row.z0 + row.z1) / 2).toFixed(3) } : null) }
  return { row: () => row }
}
